export default "__VITE_ASSET__DiVGUtBi__"